import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { FaCrown, FaArrowRight } from 'react-icons/fa';
import '../css/gtc-plan.css';

function GTCDisplayPlan(props: any) {
    const [planTitle, setPlanTitle] = useState('');
    const { service, id } = useParams();
    const navigate = useNavigate();

    const getPlanDetails = async () => {
        try {
            const data = await apiRequest({
                method: "GET",
                fn: "subscriptionplandetails",
                api: API_CONSTANTS.PRIVATE_API,
                data: {
                    plan: props.plan || "free",
                    service: service
                }
            });
            if (data && data.status == 200) {
                const apiData = data.data;
                setPlanTitle(apiData?.plan?.title || "Free Plan")
            } 
        } catch (error) {
            console.log("getPlanDetails", error)
        }
    }

    useEffect(() => {
        getPlanDetails();
    }, [props.plan])

    const clickUpgrade = async () => {
        navigate(`/service/${service}/channel/${id}/subscriptions`)
    }   
    return (
        <div className="plan-card">
            <div className="plan-content">
                <div className="plan-info">
                    <div className="current-plan">Current Subscription</div>
                    <h2 className="plan-name">
                        <FaCrown style={{ color: '#FFD700' }} />
                        {planTitle || "Free Plan"}
                    </h2>
                    <p className="plan-description">
                        Upgrade your plan to unlock more API requests and advanced features. 
                        Choose the perfect plan for your needs.
                    </p>
                </div>
                <button className="upgrade-button" onClick={clickUpgrade}>
                    Upgrade Plan
                    <FaArrowRight className="upgrade-icon" />
                </button>
            </div>
        </div>
    );
}

export default GTCDisplayPlan;